import { render, staticRenderFns } from "./SleepChart.vue?vue&type=template&id=63d39ac4&"
import script from "./SleepChart.vue?vue&type=script&lang=js&"
export * from "./SleepChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports